// DS: B5
import React from 'react';
import classnames from 'classnames';
import { Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button, { Props as ButtonProps } from '../Button';
import s from './ButtonB5.scss';

export interface Props extends ButtonProps {
  // some component from Icons/
  icon: React.ComponentType<IconProps>;
  iconProps: IconProps;
  withBackground?: boolean;
  className?: string;
  children?: React.ReactNode | undefined;
}

class ButtonB5 extends React.Component<Props> {
  render() {
    const { className, children, withBackground = true, ...rest } = this.props;
    return (
      <Button
        {...rest}
        className={classnames(
          s['button'],
          withBackground && s['with-background'],
          className
        )}
        fullWidth={false}
      >
        {this.renderIcon()}
        {children}
      </Button>
    );
  }

  renderIcon() {
    const Component = this.props.icon;
    const { className, ...rest } = this.props.iconProps;
    return <Component className={classnames(s['icon'], className)} {...rest} />;
  }
}

export default ButtonB5;
